<template>
    <div class="card-body border-top">
        <div v-html="selectedMethod.fields.fields.instructions"></div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    export default {
        name: "FieldsInstructions",
        computed: mapState({
            selectedMethod: state => state.payment.selectedMethod
        }),
        mounted() {
            this.$store.commit('setPaymentMethodData',{
                valid: true,
                data: {}
            });
        }
    }
</script>

<style scoped>

</style>
